<template>
  <div class="content" @click="toggleSidebar">
    <div class="container-fluid">
      <error-listener />
      <announcement-listener />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>
<script>
import ErrorListener from "@components/UIComponents/ErrorListener/ErrorListener.vue";
import AnnouncementListener from "@components/UIComponents/Announcements/AnnouncementListener.vue";
import { getStorageData } from "@/utils/storage";

export default {
  components: { ErrorListener, AnnouncementListener },
  mounted() {
    if (this.$hj) {
      const user = getStorageData("user");
      const identify = {
        id: user.uuid,
        email: user.email,
        fullName: user.fullName
      };

      this.$hj('identify', identify.id, identify);
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
